import React from 'react';
import { Box } from '@mui/material';
import '../../theme/newPost.css';

interface StepIconProps {
  active?: boolean;
  completed?: boolean;
  icon: React.ReactNode;
}

const StepIcon: React.FC<StepIconProps> = ({ active, completed, icon }) => {
  return (
    <Box 
      className={`new-post-step-icon ${!active && !completed ? 'new-post-step-icon-inactive' : ''}`}
    >
      {icon}
    </Box>
  );
};

export default StepIcon;
